const styles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#FAF7F1',

    '@media (max-width: 375px)': {
      alignItems: 'unset',
    },
  },
  dataContainer: {
    width: '793px',
    height: '786px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    padding: '20px',
  },
  header: {
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '100px',

    '@media (max-width: 767px)': {
      marginTop: '20px',
    },
  },
  checkIcon: {
    marginBottom: '50px',
    '@media (max-width: 767px)': {
      marginBottom: '20px',
    },
  },
  textContent: {
    fontSize: '18px',
    fontWeight: 400,
    padding: '30px',
    marginRight: '70px',
    marginLeft: '70px',
    '@media (max-width: 767px)': {
      margin: 0,
      padding: '20px 0',
    },
  },
  linkButton: {
    height: '48px',
    padding: '12px 24px 12px 24px',
    borderRadius: '50px',
    marginRight: '8px',
    backgroundColor: '#EF4821',
    color: 'white',
    border: 'none',
    marginTop: '10px',
    fontSize: '16px',
    fontWeight: 500,

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#de4723',
    },

    '@media (max-width: 425px)': {
      minWidth: '175px',
    },
  },
  divider: {
    width: '100%',
    marginTop: '60px',
    border: '1px dashed #D1D1D1',
    marginBottom: '24px',
  },
  newsLetterText: {
    fontSize: '16px',
    fontWeight: '500',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styles;
